import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.PaymentProfileListTable.';

  public static readonly paymentProfile = `${Id.prefix}paymentProfile`;
  public static readonly valuePercent = `${Id.prefix}valuePercent`;
  public static readonly supplier = `${Id.prefix}supplier`;
  public static readonly calculation = `${Id.prefix}calculation`;
}

export class LangPaymentProfileListTable {
  private constructor() {}

  public static paymentProfile(): string {
    return interpolate(Id.paymentProfile);
  }
  public static valuePercent(): string {
    return interpolate(Id.valuePercent);
  }
  public static supplier(): string {
    return interpolate(Id.supplier);
  }
  public static calculation(): string {
    return interpolate(Id.calculation);
  }
}

export class PaymentProfileListTableModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.paymentProfile, "{{glossary 'payment-profile'}}", 'Column header for payment profile name');
    register.add(Id.valuePercent, 'Value (%)', 'Column header for value percent');
    register.add(Id.supplier, "{{glossary 'supplier'}}", 'Column header for supplier');
    register.add(Id.calculation, 'Calculation', 'Column header for calculation type');
  }
}
